// Stable ids for the non-section Build items (those with no settings-nav source
// link). Shared so the producer (`useBuildNavItems`) and consumers
// (active-state logic) reference the same string.
export const DASHBOARD_BUILD_ITEM_ID = "dashboard";
export const SETTINGS_BUILD_ITEM_ID = "settings";
